import { sportsProxy } from './proxies';

export default class SportsService {
  getEventsByGroupId(eventGroupId: number): Promise<Object> {
    return sportsProxy.get(`/events?eventGroupId=${eventGroupId}`);
  }

  getEventsByIds(eventIds: number[]): Promise<Object> {
    let url = `/events`;
    eventIds.forEach((id: number, index: number) => {
      url = `${url}${index === 0 ? '?' : '&'}eventId=${id}`;
    });
    return sportsProxy.get(url);
  }

  getEvent(eventId: number): Promise<Object> {
    return sportsProxy.get(`/events?eventId=${eventId}`);
  }
}
